export function useMixinMethods() {
    const $storageUrl = path => {
        const baseUrl = import.meta.env.VITE_API_URL + '/storage';
        return `${baseUrl}${path}`;
    };

    return {
        $storageUrl,
    };
}
